import { Theme } from 'baseui';
import {
  createThemedStyled,
  createThemedUseStyletron,
  createThemedWithStyle,
} from 'baseui';
import { LightTheme, createTheme } from 'baseui/themes';
import { PrimitiveColors } from 'baseui/tokens';
import { colors } from 'baseui/tokens';

const brandColors = {
  primary: '#2C6A94',
  primary50: '#E7F1F8',
  primary100: '#D0E4F1',
  primary200: '#9DC6E2',
  primary300: '#6EABD4',
  primary400: '#3A8DC5',
  primary500: '#2C6A94',
  primary600: '#235576',
  primary700: '#1B415A',
};

type CustomTheme = Theme & {
  colorTokens: PrimitiveColors;
};

const theme = createTheme({
  colors: {
    ...brandColors,
    inputFill: LightTheme.colors.white,
    // inputBorder: brandColors.primary600,
  },
  borders: {
    inputBorderRadius: '8px',
  },
});

// createTheme no longer accepts a primitives argument; apply the primary
// font family across all typography tokens the way primitives.primaryFontFamily did.
for (const token of Object.values(theme.typography)) {
  if (token && typeof token === 'object' && 'fontFamily' in token) {
    (token as { fontFamily?: string }).fontFamily = 'Roboto, sans-serif';
  }
}

const customTheme: CustomTheme = {
  ...theme,
  colorTokens: colors,
};

export default customTheme;
export const styled = createThemedStyled<typeof theme>();
export const withStyle = createThemedWithStyle<typeof theme>();
export const useStyletron = createThemedUseStyletron<typeof theme>();
